import { createHttp } from './helpers'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER } from 'lib/constants'
import { IHTTP } from './interface'

const HTTP: IHTTP = {
  onboarding: createHttp(process.env.APP_API_ONBOARDING_URL),
  panel: createHttp(process.env.APP_API_PANEL_URL),
  paymentsApi: createHttp(process.env.APP_API_PAYMENTS_URL)
}

/**
 * @description
 * Get default headers for payment panel HTTP requests
 *
 * @returns {AxiosRequestHeaders}
 *
 * @example
 * import { getDefaultPanelHeaders } from 'lib/http'
 * const headers = {
 *     ...getDefaultPanelHeaders(),
 *     'X-Other-Header': '1234567890'
 * }
 *
 * @note
 * The function adds authorization header with bearer token
 */
export const getDefaultPanelHeaders = (): Record<string, string> => ({
  ...HEADER.acceptLanguage(),
  ...HEADER.auth.bearer(getToken()),
  ...HEADER.entityId.getFromLocalStorage(),
  ...HEADER.json
})

export default HTTP
